import CryptoJS, { AES } from 'crypto-js';

function cryptography() {
  function encrypt(valueToEncrypt, secretKey) {
    const encryptData = AES.encrypt(valueToEncrypt, secretKey).toString();
    return encryptData;
  }
  function decrypt(valueToDecrypt, secretKey) {
    const decryptArrayData = AES.decrypt(valueToDecrypt, secretKey);
    const decryptData = decryptArrayData.toString(CryptoJS.enc.Utf8);
    return decryptData;
  }

  return {
    encrypt,
    decrypt
  };
}

export default cryptography;
